import React, { useEffect, useState } from "react";
import { FiEdit } from "react-icons/fi";
import { MdOutlineFileUpload } from "react-icons/md";
import { AiOutlineSave } from "react-icons/ai";

import "./Profile.css";
import { useDispatch, useSelector } from "react-redux";
import { useLazyQuery, useMutation } from "@apollo/client";
import { UPDATE_USER_MUTATION } from "../../GraphQl/Mutations";
import { ActionCodes } from "../../constants/ActionCodes";
import uuid from "react-uuid";
import { roles } from "../../constants/Roles";
import { setProfile, updateProfile } from "../../redux/actions/user";
import { SINGLE_USER } from "../../GraphQl/Queries";
import Loader from "../../components/Loader";

const Profile = () => {
  const [edit, setEdit] = useState(false);
  const [role, setRole] = useState(localStorage.getItem("shub-roles"));
  const [trial, setTrial] = useState(false);
  const profile = useSelector((state) => state?.users?.user);
  const [currProfile, setCurrProfile] = useState(null);

  const [userDetail, setUserDetail] = useState(null);
  const [message, setMessage] = useState("");
  const dispatch = useDispatch();
  const [updateUser] = useMutation(UPDATE_USER_MUTATION, {
    variables: {
      updateUserId: localStorage.getItem("shub-userId"),
      updateUserDataInput: {
        address: {
          city: userDetail?.address?.city,
          country: userDetail?.address?.country,
          state: userDetail?.address?.state,
        },
        date_of_birth: userDetail?.date_of_birth,
        fullName: userDetail?.fullName,
        organization: {
          organizationName:
            userDetail?.userDetails?.organization?.organizationName,
        },
        phone: userDetail?.phone,
        profession: userDetail?.userDetails?.profession,
      },
    },
    onCompleted: (data) => {
      setMessage(ActionCodes.S_001);
      getProfile();
      toggleEditMode();
      setTrial(false);
    },
    onError: (err) => {
      setMessage(ActionCodes.S_001_0);
      setTrial(false);
      console.log("AFTER COMPLETION", err);
    },
  });

  const [getProfile, { error, loading, data }] = useLazyQuery(SINGLE_USER, {
    variables: {
      getUserByIdId: localStorage.getItem("shub-userId"),
    },
    onCompleted: (data) => {
      localStorage.setItem(
        "shub-userProfile",
        JSON.stringify(data?.getUserById)
      );
      dispatch(updateProfile(data?.getUserById));
      setMessage(null);
    },
    onError: (error) => {
      setMessage(error);
    },
  });
  useEffect(() => {
    if (profile == null) getProfile();
    setUserDetail(profile);
  }, [profile]);

  const toggleEditMode = () => {
    setEdit(!edit);
  };

  const saveDetails = () => {
    setTrial(true);
    // console.log("saving", userDetail);
    // console.log("userDetails", userDetail.userDetails.profession);
    updateUser();
  };

  useEffect(() => {
    if (edit)
      document
        .querySelectorAll("input")
        .forEach((input) => (input.disabled = false));
    else if (!edit)
      document
        .querySelectorAll("input")
        .forEach((input) => (input.disabled = true));
  }, [edit]);

  return (
    <section className='profileWrapper'>
      <div className='sectionHeaderWrapper flex items-center content-between'>
        <div className='sectionHeaderTitle'> Profile </div>
      </div>
      {loading ? (
        <>Loading...</>
      ) : (
        <div className='sectionContentWrapper'>
          <div className='profileWrapper'>
            <div className='profileTopWrapper flex wrap items-center content-between'>
              <div className='profileDiv flex  items-center content-start'>
                <div className='profileImageWrapper w-[45px] h-[45px] lg:w-[80px] lg:h-[80px]'>
                  <img
                    src={
                      "https://avatars.dicebear.com/api/open-peeps/" +
                      userDetail?.fullName +
                      ".svg"
                    }
                    alt={userDetail?.fullName}
                    className='profileImage w-full h-full'
                    id='profileImage'
                  />
                  {edit && (
                    <>
                      <label
                        htmlFor='profileImageInput'
                        id='profileImageUploadBtn'
                        className='btn btn-primary'
                      >
                        <MdOutlineFileUpload />
                      </label>
                      <input
                        type='file'
                        name='profileImageInput'
                        id='profileImageInput'
                        // onChange={previewFile}
                      />
                    </>
                  )}
                </div>
                <div className='profileDetails'>
                  <div className='profileName'>
                    {userDetail?.user?.fullName ||
                      userDetail?.fullName ||
                      "Unavailable"}
                  </div>
                  <div className='profileRole'>{role}</div>
                </div>
              </div>
              {edit && (
                <div
                  className='profileEditBtn btn btn-primary flex items-center'
                  onClick={() => {
                    saveDetails();
                  }}
                >
                  <span>
                    {trial ? <Loader color='#fff' /> : <AiOutlineSave />}
                  </span>
                  &nbsp;
                  <span>Save</span>
                </div>
              )}
              {!edit && (
                <div
                  className='profileEditBtn btn btn-primary flex items-center'
                  onClick={() => toggleEditMode()}
                >
                  <span>
                    <FiEdit />
                  </span>
                  &nbsp;
                  <span>Edit</span>
                </div>
              )}
            </div>
            <div className='profileContentWrapper'>
              <form>
                <div className='profileFormWrapper'>
                  <div className='inputGroup flex items-center'>
                    <div className='label'>Full name</div>
                    <input
                      type='text'
                      className='form-control'
                      placeholder={userDetail?.fullName || "Enter full name"}
                      defaultValue={userDetail?.fullName}
                      id='fullNameInput'
                      onKeyUp={(e) =>
                        setUserDetail({
                          ...userDetail,
                          fullName: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className='inputGroup flex items-center'>
                    <div className='label'>Email</div>
                    <input
                      type='email'
                      className='form-control'
                      placeholder={userDetail?.email || "Enter email"}
                      defaultValue={userDetail?.email}
                      id='emailInput'
                      onKeyUp={(e) =>
                        setUserDetail({
                          ...userDetail,
                          email: e.target.value,
                        })
                      }
                    />
                  </div>
                  {/* <div className="inputGroup flex items-center">
                    <div className="label">Password</div>
                    <input
                      type="password"
                      className="form-control"
                      // placeholder="slggourav@gmail.com"
                      defaultValue="*******"
                      id="passwordInput"
                      disabled
                    />
                  </div> */}
                  <div className='inputGroup flex items-center'>
                    <div className='label'>Date of Birth</div>
                    <input
                      type='date'
                      className='form-control'
                      id='dateOfBirthInput'
                      placeholder={
                        userDetail?.date_of_birth || "Enter Date of Birth"
                      }
                      defaultValue={userDetail?.date_of_birth}
                      onChange={(e) =>
                        setUserDetail({
                          ...userDetail,
                          date_of_birth: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className='inputGroup flex items-center'>
                    <div className='label'>City</div>
                    <input
                      type='text'
                      className='form-control'
                      id='cityInput'
                      placeholder={userDetail?.address?.city || "Enter City"}
                      defaultValue={userDetail?.address?.city}
                      onKeyUp={(e) =>
                        setUserDetail({
                          ...userDetail,
                          address: {
                            ...userDetail?.address,
                            city: e.target.value,
                          },
                        })
                      }
                    />
                  </div>
                  <div className='inputGroup flex items-center'>
                    <div className='label'>State</div>
                    <input
                      type='text'
                      className='form-control'
                      id='stateInput'
                      placeholder={userDetail?.address?.state || "Enter state"}
                      defaultValue={userDetail?.address?.state}
                      onKeyUp={(e) =>
                        setUserDetail({
                          ...userDetail,
                          address: {
                            ...userDetail?.address,
                            state: e.target.value,
                          },
                        })
                      }
                    />
                  </div>
                  <div className='inputGroup flex items-center'>
                    <div className='label'>Country</div>
                    <input
                      type='text'
                      className='form-control'
                      id='countryInput'
                      placeholder={
                        userDetail?.address?.country || "Enter country"
                      }
                      defaultValue={userDetail?.address?.country}
                      onKeyUp={(e) =>
                        setUserDetail({
                          ...userDetail,
                          address: {
                            ...userDetail?.address,
                            country: e.target.value,
                          },
                        })
                      }
                    />
                  </div>
                  <div className='inputGroup flex items-center'>
                    <div className='label'>Organization</div>
                    <input
                      type='text'
                      className='form-control'
                      placeholder={
                        userDetail?.userDetails?.organization
                          ?.organizationName || "Enter your organization Name"
                      }
                      defaultValue={
                        userDetail?.userDetails?.organization?.organizationName
                      }
                      id='organizationField'
                      onKeyUp={(e) =>
                        setUserDetail({
                          ...userDetail,
                          userDetails: {
                            ...userDetail?.userDetails,
                            organization: {
                              // organizationId: uuid(),
                              ...userDetail?.userDetails?.organization,
                              organizationName: e.target.value,
                            },
                          },
                        })
                      }
                      // defaultValue={userDetail?.adminDetails?.company}
                    />
                  </div>
                  <div className='inputGroup flex items-center'>
                    <div className='label'>Profession</div>
                    <input
                      type='text'
                      className='form-control'
                      placeholder={
                        userDetail?.userDetails?.profession ||
                        "Enter your profession"
                      }
                      defaultValue={userDetail?.userDetails?.profession}
                      id='professionField'
                      onKeyUp={(e) =>
                        setUserDetail({
                          ...userDetail,
                          userDetails: {
                            ...userDetail?.userDetails,
                            profession: e.target.value,
                          },
                        })
                      }
                    />
                  </div>
                  <div className='inputGroup flex items-center'>
                    <div className='label'>Phone</div>
                    <input
                      type='text'
                      className='form-control'
                      id='phoneInput'
                      placeholder={
                        userDetail?.phone || "Enter your phone number"
                      }
                      defaultValue={userDetail?.phone}
                      onKeyUp={(e) =>
                        setUserDetail({
                          ...userDetail,
                          phone: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Profile;
